export const formatFileSize = (bytes, unit) => {
    let target = unit;
    const units = {
        'TB': 1024 ** 4,
        'GB': 1024 ** 3,
        'MB': 1024 ** 2,
        'KB': 1024 ** 1,
        'B': 1024 ** 0,
    };
    if (!target) {
        for (const [name, value] of Object.entries(units).toSorted((a, b) => b[1] - a[1])) {
            if (bytes >= value) {
                target = name;
                break;
            }
        }
    }
    return `${(bytes / units[target]).toFixed(2)} ${target}`;
};
import { Instant, LocalDate, LocalTime, DateTimeFormatter, ZoneId, Locale } from './datetime';
export const formatDollars = (x) => {
    return new Intl.NumberFormat('en-US', {
        'style': 'currency',
        'currency': 'USD',
        'minimumFractionDigits': 2,
        'maximumFractionDigits': 2,
    }).format(Math.round(x * 100) / 100);
};
export const formatNumber = (x) => {
    return new Intl.NumberFormat('en-US', {}).format(x);
};
export const formatNumberD = (x, digits = 2) => {
    return new Intl.NumberFormat('en-US', {
        'maximumFractionDigits': digits,
    }).format(x);
};
export const calendarFormat = (date, fmt, culture) => {
    const locale = culture || 'en-US';
    const options = fmt === 'P' || fmt === 'PP'
        ? { year: 'numeric', month: 'short', day: 'numeric' }
        : fmt === 'p'
            ? { hour: 'numeric', minute: '2-digit' }
            : { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };
    return new Intl.DateTimeFormat(locale, options).format(date);
};
export const calendarParse = (value) => new Date(Date.parse(value));
export const calendarStartOfWeek = (date) => {
    const d = new Date(date);
    const diff = d.getDay();
    d.setDate(d.getDate() - diff);
    return d;
};
export const calendarGetDay = (date) => date.getDay();
export const formatDate = (x) => {
    const pattern = DateTimeFormatter.ofPattern('M/d/yyyy').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDate - fallthrough', x), '#ERROR#'));
};
export const formatDateLong = (x) => {
    const pattern = DateTimeFormatter.ofPattern('EEEE MMMM d, yyyy').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDate - fallthrough', x), '#ERROR#'));
};
export const formatTime = (x) => {
    const pattern = DateTimeFormatter.ofPattern('h:mm a').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalTime
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatTime - fallthrough', x), '#ERROR#'));
};
export const formatDateTime = (x) => {
    const pattern = DateTimeFormatter.ofPattern('M/d/yyyy @ h:mm a').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDateTime - fallthrough', x), '#ERROR#'));
};
export const formatDatetimeLong = (x) => {
    const pattern = DateTimeFormatter.ofPattern('EEEE MMMM d, yyyy @ h:mm a').withLocale(Locale.US);
    return (x === null
        ? ''
        : x instanceof LocalDate
            ? x.format(pattern)
            : x instanceof Instant
                ? x.atZone(ZoneId.SYSTEM).format(pattern)
                : (console.error('formatDate - fallthrough', x), '#ERROR#'));
};
export const formatPhone = (raw) => {
    const _formatPhone = (x) => {
        switch (x.length) {
            case 11:
                return x.startsWith('1') ? _formatPhone(x.substring(1)) : x;
            case 10:
                return `(${x.substring(0, 3)}) ${x.substring(3, 6)}-${x.substring(6)}`;
            default:
                return raw;
        }
    };
    return _formatPhone(raw.replaceAll(/\D+/g, ''));
};
export default {
    formatDollars,
    formatNumber,
    formatNumberD,
    formatDate,
    formatDateLong,
    formatTime,
    formatDatetimeLong,
    formatPhone,
    formatFileSize,
    calendarFormat,
    calendarParse,
    calendarStartOfWeek,
    calendarGetDay,
};
/* BACKUP
import { Instant,Instant_,LocalDate,LocalDate_,LocalTime,LocalDateTime,DateTimeFormatter,ZoneId,Locale } from './datetime'

export const formatDollars = (x:number) => {
  return new Intl.NumberFormat('en-US',{
    'style':'currency',
    'currency':'USD',
    'minimumFractionDigits':2,
    'maximumFractionDigits':2,
  }).format(Math.round(x*100)/100)
}
export const formatNumber = (x:number) => {
  return new Intl.NumberFormat('en-US',{
  }).format(x)
}
export const formatNumberD = (x:number,digits=2) => {
  return new Intl.NumberFormat('en-US',{
    'maximumFractionDigits':digits,
  }).format(x)
}
export const formatDate = (x:LocalDate_ | Instant_ | null) : string => {
  const pattern = DateTimeFormatter.ofPattern('M/d/yyyy').withLocale(Locale.US)
  return (
    x === null
    ? ''
    : x instanceof LocalDate
    ? x.format(pattern)
    : x instanceof Instant
    ? x.atZone(ZoneId.SYSTEM).format(pattern)
    : (console.error('formatDate - fallthrough',x),'#ERROR#')
  )
}
export const formatDateLong = (x:LocalDate_ | Instant_ | null) : string => {
  const pattern = DateTimeFormatter.ofPattern('EEEE MMMM d, yyyy').withLocale(Locale.US)
  return (
    x === null
    ? ''
    : x instanceof LocalDate
    ? x.format(pattern)
    : x instanceof Instant
    ? x.atZone(ZoneId.SYSTEM).format(pattern)
    : (console.error('formatDate - fallthrough',x),'#ERROR#')
  )
}
export const formatTime = (x:LocalTime | Instant_ | null) : string => {
  const pattern = DateTimeFormatter.ofPattern('h:mm a').withLocale(Locale.US)
  return (
    x === null
    ? ''
    : x instanceof LocalTime
    ? x.format(pattern)
    : x instanceof Instant
    ? x.atZone(ZoneId.SYSTEM).format(pattern)
    : (console.error('formatTime - fallthrough',x),'#ERROR#')
  )
}
export const formatDateTime = (x:LocalDateTime | Instant_ | null) : string => {
  const pattern = DateTimeFormatter.ofPattern('M/d/yyyy h:mm a').withLocale(Locale.US)
  return (
    x === null
    ? ''
    : x instanceof LocalDate
    ? x.format(pattern)
    : x instanceof Instant
    ? x.atZone(ZoneId.SYSTEM).format(pattern)
    : (console.error('formatDateTime - fallthrough',x),'#ERROR#')
  )
}
export const formatDatetimeLong = (x:LocalDateTime | Instant_ | null) : string => {
  const pattern = DateTimeFormatter.ofPattern('EEEE MMMM d, yyyy h:mm a').withLocale(Locale.US)
  return (
    x === null
    ? ''
    : x instanceof LocalDate
    ? x.format(pattern)
    : x instanceof Instant
    ? x.atZone(ZoneId.SYSTEM).format(pattern)
    : (console.error('formatDate - fallthrough',x),'#ERROR#')
  )
}
export const formatPhone = (raw:string) : string => {
  const _formatPhone = (x:string) : string => {
    switch(x.length)
    {
      case 11:
        return x.startsWith('1') ? _formatPhone(x.substring(1)) : x
      case 10:
        return `(${x.substring(0,3)}) ${x.substring(3,6)}-${x.substring(6)}`
      default:
        return raw
    }
  }
  return _formatPhone(raw.replaceAll(/\D+/g,''))
}

type FileSizeUnit = 'TB' | 'GB' | 'MB' | 'KB' | 'B'
export const formatFileSize = (bytes:number,unit?:FileSizeUnit) => {
  let target = unit
  const units : { [_ in FileSizeUnit]:number } = {
    'TB':1024 ** 4,
    'GB':1024 ** 3,
    'MB':1024 ** 2,
    'KB':1024 ** 1,
     'B':1024 ** 0,
  }

  if(!target)
  {
    for(const [name,value] of Object.entries(units).toSorted((a,b) => b[1] - a[1]))
    {
      if(bytes >= value)
      {
        target = name as FileSizeUnit
        break
      }
    }
  }

  return `${(bytes / units[target!]).toFixed(2)} ${target}`
}


export default {
  formatDollars,
  formatNumber,
  formatNumberD,
  formatDate,
  formatDateLong,
  formatTime,
  formatDatetimeLong,
  formatPhone,
  formatFileSize,
}
*/
